module.exports = "/dist/assets/images/zoom_out.svg";